export const spanishLocal = {
        "translation": {
                "LOAD_USER_INFO": "Validando datos",
                "ACCESS_DIR": "Accesos Recientes",
                "RES_INFO": "Info. Recurso",
                "AUDIT_INFO": "Estado de auditoría",
                "AUDIT_DOCS": "Auditoría de documentos",
                "AUDIT_INFO_SHORT": "Info. Auditoría",
                "AUDIT_INFO_LONG": "Información de auditoría",
                "CONT": "Contratista",
                "APPROVEDS": "Aprobados",
                "APPROVED": "Aprobado",
                "REJECTED": "Rechazado",
                "REJECTEDS": "Rechazados",
                "PDG_EVAL": "En evaluación",
                "AUDIT_DOC": "Auditoría de documentos",
                "DOC": "Documento",
                "DOCS_CONT": "Documentos de Contratista",
                "DOCS_EMPS": "Documentos de empleados",
                "DOCS_VEHS": "Documentos de vehículos",
                "DOCS": "Documentos",
                "SBT_QUOT": "Presentar cuotas",
                "SBT_WHIT_PP": "Presentación parcial",
                "SBT_WHIT_PP_CRITERION": "El calculo de presentaciones parciales considera la cantidad máxima de planes de pago activos configurada",
                "DATE": "Fecha",
                "STATE_DOCTION": "Estado de documentos",
                "STATE_RESS": "Estado de recursos",
                "STATE_RES_ENTRY": "Estado del recurso para el ingreso",
                "DOC_DUE_BY_CRITERION": "Documentación adeudada por criterio",
                "DOCTION": "Documentación",
                "DOC_REQ": "Documentación requerida",
                "EMP": "Empleado",
                "EMPS": "Empleados",
                "VEH": "Vehículo",
                "VEHS": "Vehículos",
                "CONTRACT": "Contrato",
                "CONTRACTS": "Contratos",
                "CONTRACTS_MENU": "Contratos",
                "RPT_SUB_HIS": "Historial de presentaciones",
                "RPT_SUB_STS": "Estado de presentación",
                "DOC_SUB": "Presentación de documentos",
                "MCONT": "Contratistas",
                "MCONT_RES_STS": "Estado de recursos",
                "SCONT_SUB_STS": "Estado de presentaciones",
                "FILTERS": "Filtros",
                "SCH_FILT": "Filtrar",
                "FILT_FOR": "Filtrar por",
                "REQ_DOC": "Doc requerida",
                "SEARCH_FILTER": "Busque por algún filtro...",
                "REG_NUM": "Cantidad de registros",
                "COPY": "Copiar",
                "COPIED": "Copiado",
                "DOWNLOAD_PAGE": "Descargar Página",
                "DOWNLOAD_ALL": "Descargar todo",
                "DOWNLOAD": "Descargar",
                "CRITERION": "Criterio",
                "CRITERION_DESCRIP": "Detalle criterio",
                "DOC_COD": "Cod documento",
                "DOC_NAME": "Nombre doc",
                "DOC_PROX_EXRE": "Doc Prox. a vencer.",
                "SEARCH_VEH": "Buscar Vehículo",
                "SEARCH_EMP": "Buscar Empleado",
                "SEARCH": "Buscar",
                "INFO_RES": "Información del recurso",
                "AUDIT_RESS": "Auditoría de recursos",
                "RES": "Recurso",
                "RESS": "Recursos",
                "TPE_RES": "Tipo de recurso",
                "ID": "ID",
                "PATENT": "Patente",
                "ID_PATENT": "ID/Patente",
                "NAME": "Nombre",
                "BND_MOD": "Marca/Modelo",
                "NAME_BND_MOD": "Nombre/ Marca/ Modelo",
                "STION_RES": "Situación del recurso",
                "STION": "Situación",
                "STE_CURR_DATE": "Estado a la fecha",
                "STE_APTDE": "Aptitud",
                "EXRE": "Vencimiento",
                "PNT_DOC": "Presentar Doc",
                "STATE": "Estado",
                "CONTRACTS_STATUS": "Estado de contratos",
                "EMP_PHOLDER_ENTRY": "Buscar por ID o nombre",
                "VEH_PHOLDER_ENTRY": "Buscar por Patente o nombre",
                "APT_ENTRY": "Apto",
                "UN_APT_ENTRY": "No Apto",
                "STFING": "Satisfactorio",
                "UN_STFING": "No satisfactorio",
                "CUIL": "Cuil",
                "RBO": "Rubro",
                "RANK": "Clasificaciones",
                "ACTIVE": "Activo",
                "INACTIVE": "Inactivo",
                "LOW": "De baja",
                "LASTS": "Últimos",
                "DAYS": "Días",
                "OPENING": "Apertura",
                "ENTRY": "Ingreso",
                "CHANGE": "Cambiar",
                "APT": "Apto",
                "PART_APT": "Apto parcial",
                "UN_APT": "No Apto",
                "PENDING_CLOSE": "Pendientes de cierre",
                "VALTY": "Vigencia habilitación",
                "VALIDITY": "Vigencia habilitación",
                "EXIT": "Salir",
                "SUBMITED": "Presentado",
                "PDING": "Pendiente",
                "PDING_OP": "Pendiente (Vencidos y no presentados)",
                "NOT_SUBMITED": "No presentado",
                "EXPIRED": "Vencido",
                "CREDENTIAL": "Credencial",
                "APPLY": "Aplicar",
                "SHOW_MORE": "Mostrar más",
                "NO_DATA": "No hay datos a mostrar",
                "YES": "Sí",
                "NO": "No",
                "DEPNDS_REL": "Relación de dependencia",
                "SUB_CONTRACT": "Subcontratado",
                "CONCEPT": "Concepto",
                "OTHER": "Otro",
                "UP_DATE": "Fecha de alta",
                "TYPE_CONTRACT": "Tipo de contratación",
                "IS_DRIVER": "Es conductor",
                "CODE": "Código",
                "DESCRIPTION": "Descripción",
                "CONCEPT_DESCRIP": "Descripción del concepto",
                "DATE_SINCE": "Fecha Desde",
                "DATE_UNTIL": "Fecha Hasta",
                "DATE_PRESENT": "Fecha de presentación",
                "DATE_AUDIT": "Fecha de auditoría",
                "CORRESPONDING_TO": "Correspondiente a ",
                "EVENTUALITY": "Eventualidad",
                "VALUE": "Valor",
                "MORE_INFO": "Más información",
                "EXCEPTION_UNTIL": "Puede ingresar hasta el ",
                "STATUS_TO_ENTRY": "Estado del recurso",
                "SEND_TO": "Enviar todos",
                "SEND": "Enviar",
                "LAST_ONE_DAYS": "Últimos 24 horas",
                "LAST_SEVEN_DAYS": "Últimos 7 días",
                "LAST_SEVENTEEN_DAYS": "Últimos 15 días",
                "LAST_THRITY_DAYS": "Últimos 30 días",
                "SELECT": "Selecciona",
                "HELLO": "Hola!",
                "FILTER_DOCS": "Filtros de Documentos",
                "FILTER_RES": "Filtros de Recursos",
                "NO_DATA_SEARCH": "No hay resultados de búsqueda.",
                "SHOW_ALL": "Mostrar todos",
                "ERROR_PAGE_TITTLE": "Error, página no encontrada",
                "ERROR_TENANT_TITTLE": "Error, la instacia no se encuentra configurada",
                "ERROR_PAGE_MESSAGE": "Lo sentimos, no se pudo encontrar la página solicitada. Por favor contáctese con el administrador.",
                "ERROR_TENANT_MESSAGE": "Por favor contactese con Exactian.",
                "ERROR_PAGE_GO_TO": "Volver al inicio",
                "ERROR_TENANT_GO_TO": "Ir a Exactian",
                "NO_DOCUMENTS_LEFT": "No hay documentación adeudada",
                "NO_DATA_PERIOD_LEFT": "No hay información en el periodo seleccionado",
                "ERASE": "Borrar",
                "FIRSTWORD_MSG_LOAD_DOCS_STATUS": "Presione",
                "FIRST_KEY_WORD_LOAD_DOCS_STATUS": "Cargar información",
                "SECONDWORD_MSG_LOAD_DOCS_STATUS": "para visualizar este gráfico o",
                "SECOND_KEY_WORD_LOAD_DOCS_STATUS": "Detalle general",
                "THIRDWORD_MSG_LOAD_DOC_STATUS": "para ver más información.",
                "MSG_NOT_TO_GO": "* Cuando comience la carga no debe salirse de la pantalla.",
                "PAST_DUE_HISTORY": "Documentación adeudada",
                "ALL_APTITUDES": "Todas las situaciones",
                "ALL_AUDITS": "Todos los estados",
                "ALL_CONTRACTS": "Todos los contratos",
                "ALL_CRITERION": "Todos los criterios",
                "ALL_DOCS": "Todos los documentos",
                "ALL_EMP": "Todos los empleados",
                "ALL_VEH": "Todos los Vehículos",
                "ALL_OPENINGS": "Todos las aperturas",
                "ALL_EVENTIUALITIES": "Todas las eventualidades",
                "ALL_RESOURCES": "Todos los recursos",
                "ALL_CLASSIFICATION": "Todas las clasificaciones",
                "HISTORY": "Historial",
                "FROM": "Desde",
                "UNTIL": "Hasta",
                "PERIOD": "Período",
                "SUBMIT_DOC": "Presentar documento",
                "AUDITOR": "Auditor",
                "SHOW_DETAIL": "Ver detalle",
                "GLOBAL_PRESENTATION": "Presentación global",
                "INDVIDUAL_PRESENTATION": "Presentación individual",
                "ATTACH": "Adjunto",
                "DELETE": "Eliminar",
                "SHOW_FILE": "Visualizar archivo",
                "CANCEL": "Cancelar",
                "DATE_RANGE": "Rango de fechas",
                "SITUATION_HISTORY": "Situación histórica",
                "ACCEPT": "Aceptar",
                "LOAD_FILE": "Archivo cargado",
                "SELECT_TWO": "Selecciona",
                "OR_DRAG": "o arrasta un documento",
                "ACCEPT_FORMATS": "Formatos compatibles",
                "MAX_SIZE": "Tamaño máximo",
                "MAX_SIZE_ERROR": "Archivo mayor a",
                "ACCEPT_FORMATS_ERROR": "Formato de archivo no aceptado",
                "IN_EVALUATION_FROM": "En evaluación desde",
                "SELECT_TYPERES_O_DOC": "Debe marcar Tipo de recurso o un Documento",
                "NO_INSTRUCTIONS": "Sin Instrucciones",
                "SERVER_ERROR": "Error del servidor",
                "REPEAT_SUBMIT_ERROR": "Ya existe una presentación para el documento/recurso/período",
                "ERROR_SUBMIT_TITTLE": "Error en la subida del documento",
                "ERROR_SUBMIT_SERVER": "Hubo un problema en la subida del documento",
                "SUCCESS_SUBMIT_TITTLE": "¡Listo!",
                "SUCCESS_SUBMIT_MESSAGE": "El documento fue presentado con éxito. Pronto recibirás una respuesta del auditor.",
                "WARNING": "Advertencia",
                "REPLACE_WARNING": "Ya existe un documento que coincide con esas fechas. ¿Usted desea reemplazarlo?",
                "PRESET_DATE_INFO": "Fecha seteada automáticamente, la misma puede ser modificada",
                "DELETE_NEXT_DOC": "Usted está por eliminar el siguiente documento:",
                "SURE_TO_CONTINUE": "¿Está seguro de continuar?",
                "NO_DOC_DUE": "Sin documentación adeudada",
                "DOC_DUE_NUM_PART_ONE": "Documentación  adeudada, en los últimos",
                "DOC_DUE_NUM_PART_TWO": "meses. Revisar historial",
                "GLOBAL_DOC_UPLOAD": "Carga global de documentos",
                "UPLOAD_FILE": "Subir archivo",
                "CONTINUE": "Continuar",
                "CONFIRM": "Confirmar",
                "REPLACE_PRES_IF_HAS_DUP": "Reemplazar presentación en caso de duplicación.",
                "TITLE_GLOBAL_DOC_STEP1": "Seleccione el tipo de documento que desea cargar de forma global",
                "TITLE_GLOBAL_DOC_STEP2": "Seleccione todos los recursos a los que les desea cargar el documento elegido previamente.",
                "FILE_NOT_FOUND": "No se encontró el archivo.",
                "SELECT_ALL": "Seleccionar todos",
                "TITLE_EXP_IMP_STEP2": "Descarga o sube el archivo con los recursos",
                "DOWNLOAD_FILE": "Descargar archivo",
                "ERROR": "Error",
                "IMPORT_ERROR_RES_TXT": "registro/s que no coincide/n con la nómina. Solamente se importarán los recursos coincidentes.",
                "FILE_HAVE": "El archivo contiene",
                "EXP_IMP_BTN_STEP2": "Exportar / Importar archivo",
                "UPLOAD_OTHER_FILE": "Subir otro archivo",
                "WANT_HAVE_SAMPLE_FILE": "¿Deseas tener el archivo de ejemplo?",
                "TEXT_EXP_IMP_STEP2": "El archivo de ejemplo incluye todos los recursos a los que les puedes presentar el documento elegido previamente.",
                "SELECTED": "Seleccionado/s",
                "NO_EXPIRATION": "Sin vencimiento",
                "RESOURCE_INFO": "Detalle del recurso",
                "EXPORT": "Exportar",
                "GENERAL_REPORT": "Reporte General",
                "CONTRACTOR": "Contratista",
                "IMPORT_ERROR_STRUCTURE_TXT": "Por favor verifique que su archivo contenga una columna llamada",
                "NOT_EDIT_COL": "IMPORTANTE!: No editar el nombre de las columnas.",
                "ERROR_IMP": "Error de importación",
                "ERROR_FORMAT": "Error de formato",
                "PREVIEW": "Previsualización",
                "Total": "Total",
                "DRIVE": "Conduce",
                "BULK_UPLOAD_DETAIL": "Detalle de carga masiva ",
                "VALTY_WORD": "Vigencia",
                "DELETE_PRES": "Eliminar presentación",
                "DELETE_PRES_SUCCESS": "La presentación se eliminó correctamente!",
                "DELETE_PRES_ERROR": "No se pudo eliminar la presentacion",
                "DELETE_PRES_ERROR_MSG": "Ocurrió un problema para eliminar el archivo.",
                "OPEN_FILE_IN_NEW_TAB": "El archivo se abrió en una nueva pestaña del navegador.",
                "TOTAL_PRESS": "Presentación total",
                "DOC_PERIOD": "Documentación correspondiente a",
                "SUCCESS_SUBMIT_MESSAGE_TWO": "El documento fue presentado con éxito.",
                "VALIDITY_DATE": "Fecha de vigencia",
                "VALIDITY_ERROR_MESSAGE": "La fecha hasta tiene que ser mayor a la fecha desde",
                "USER_NAME": "Usuario",
                "PASSWORD": "Contraseña",
                "HELLO_AGAIN": "¡Hola de nuevo!",
                "RECOVER_PASSWORD": "Recuperar contraseña",
                "GET_INTO": "Ingresar",
                "ENTER_USER_NAME": "Ingresa tu usuario",
                "ENTER_PASSWORD": "Ingresa tu contraseña",
                "ERROR_LOGIN_CREDENTIALS": "Credenciales Incorrectas!",
                "ENTER_MAIL": "Ingresa tu Email",
                "CHOOSE_OPENING": "Selecciona una",
                "CHANGE_OPENING": "Cambiar apertura",
                "CHANGE_BUILDING": "Cambiar edificio",
                "ENTER_MAIL_AND_USER_TO_RESET": "Ingresa tu email y usuario para restablecer la contraseña",
                "WRONG_USER_ERROR": "El usuario ingresado no existe",
                "INSTANCE_INFO_ERROR": "No se encontró la instancia",
                "CHECK_YOUR_MAIL": "Revisa tu email",
                "WE_SEND_A_MAIL_TO": "Te hemos enviado un email a",
                "FOR_RESET_PASSWORD": "para que puedas restablecer la contraseña",
                "DID_NOT_ARRIVE_THE_MAIL": "¿No te llegó el email?",
                "REMEMBER_CHECK_SPAM": "Recuerda revisar la bandeja de Spam",
                "RESEND_MAIL": "Reenviar email",
                "CHANGE_MAIL": "Cambiar email",
                "WAS_SEND": "Enviado",
                "WELCOME": "Te damos la bienvenida",
                "NEW_PASSWORD": "Nueva contraseña",
                "MY_ACCOUNT": "Mi cuenta",
                "REPORTS": "Reportes",
                "CONFIG": "Configuraciones",
                "HELP": "Ayuda",
                "LOGGOUT": "Cerrar sesión",
                "SCAN_OR_CODE_DNI": "Coloca el celular frente al QR o código del DNI",
                "MANUAL_ENTRY": "Ingreso manual",
                "WRITE_ID": "Escribe el número de identificación o DNI.",
                "PASS_CREATED": "Contraseña creada con éxito",
                "ENABLED": "Habilitado",
                "NOT_ENABLED": "No Habilitado",
                "APT_TO_ENTRY": "Apto para ingresar",
                "NOT_APT_TO_ENTRY": "No apto para ingresar",
                "STATUS_DETAIL": "Detalle de estado",
                "SEARCH_CODE_OR_SCAN": "Buscar por DNI | ID o escanear QR",
                "MAX_EIGHT_CARACT_ALLOW": "Minimo de 8 caracteres permitidos",
                "TO_USE_CAMERA_NEED_PERMISSIONS": "Para el uso del escaner se necesitan los permisos de la cámara",
                "ALLOW_USE": "Permitir uso",
                "INSTANCE_NOT_CONFIG_TO_ENTRY": "Instancia no configurada para ingresos",
                "CREATE_PASS": "Crear contraseña",
                "WRITE_NEW_PASS": "Ingresa una nueva contraseña para tu cuenta",
                "CONFIRM_PASS": "Confirmar contraseña",
                "MIN_EIGHT_MAX_FIFTY_CARACT": "Mínimo 8 caracteres y maximo 50 caracteres",
                "UPPERCASE": "Mayúcula",
                "LOWERCASE": "Minúscula",
                "NUMBER": "Número",
                "EMAIL": "Email",
                "VALIDATING": "Validando",
                "SELECT_CONTRACT": "Selecciona un contratista",
                "PERSON_ENTRY_WITH": "La persona ingresa con",
                "SELECT_VEH": "Selecciona vehículo",
                "ENTRY_DETAIL": "Detalle de ingreso",
                "WRITE_VISIT_DATA": "Ingresa los datos de la visita",
                "SUCCESS_ACCESS_DESC": "El ingreso ha sido realizado con éxito",
                "VISIT": "Visita",
                "VISITS": "Visitas",
                "HOURS": "Horas",
                "RES_BY_OPENINGS": "Recursos por aperturas",
                "RES_BY_HOURS": "Recursos por horas",
                "ADDITIONAL_INFO": "Información adicional",
                "CLASSIFICATION": "Clasificación",
                "COLOR": "Color",
                "ENGINE_NUMBER": "Número de motor",
                "CHASSIS_NUMBER": "Número de chásis",
                "ASSIGNED": "asignado",
                "DATE_HOUR_EXIT": "Fecha y hora de egreso",
                "DATE_HOUR_ENTRY": "Fecha y hora de ingreso",
                "HOUR": "Hora",
                "SAVE": "Guardar",
                "EDIT": "Editar",
                "DEPARTURE": "Egreso",
                "EXIT_DETAIL": "Detalle de egreso",
                "PERSON_EXIT_WITH": "La persona egresa con",
                "SUCCESS_EXIT_DESC": "El egreso ha sido realizado con éxito",
                "TOKEN_ERROR": "Finalizo la sesion",
                "ACCESS_WITH_CAR": "La persona ingresa con vehículo propio o de la empresa.",
                "EXIT_WITH_CAR": "La persona egresa con vehículo propio o de la empresa.",
                "NEXT": "Siguiente",
                "GET_BACK": "Volver",
                "CONT_MAIN": "Contratista Principal",
                "SCAN_QR_OR_ID": "Escanea QR o DNI",
                "NO_CAR": "Sin vehículo",
                "NO_CAR_ACCESS": "La persona ingresa sin vehículo",
                "NO_CAR_EXIT": "La persona egresa sin vehículo",
                "OBSERVATIONS": "Observaciones",
                "DENY": "Denegar",
                "SCAN_ERROR": "Código escaneado no válido",
                "RES_BY": "Recursos por",
                "RES_OF": "Recursos de",
                "STATUS_ERROR_ACCESS": "El empleado, vehiculo que se intenta ingresar no puede ingresarse debido a su estado",
                "STATUS_ERROR_ACCESS_VISIT": "La visita que se intenta ingresar no puede ingresarse debido a su estado",
                "CONCURRENCY_ERROR_ACCESS": "El empleado, vehiculo que se intenta ingresar ya esta ingresado",
                "CONCURRENCY_ERROR_EXIT": "El empleado, vehiculo que se intenta egresar no esta ingresado",
                "CONCURRENCY_ERROR_ACCESS_VISIT": "La visita que se intenta ingresar ya esta ingresada",
                "CONCURRENCY_ERROR_EXIT_VISIT": "La visita que se intenta egresar no esta ingresada",
                "PARAM_MISSMATCH": "La visita corresponde a un empleado activo o de baja no apto",
                "VISIT_REASON": "Motivo de visita",
                "EMPLOYEE_NO_ACCESS_ERROR": "El empleado no esta habilitado para ingresar",
                "FINISH": "Finalizar",
                "VEHICLE_DATA_NO_CONFIRM": "Existe información de un vehículo sin confirmar.",
                "DO_YOU_WANT_TO_ADD": "¿Desea agregarla?",
                "ADD": "Agregar",
                "VEHICLE_DATA_NO_COMPLETED": "Ingresó información incompleta de un nuevo vehículo.",
                "DO_YOU_WANT_TO_COMPLETE": "¿Desea completar la información?",
                "COMPLETE": "Completar",
                "FULL_NAME": "Nombre completo",
                "ENTER_FULL_NAME_OF_VISIT": "Ingresa nombre completo de la visita",
                "ENTER_VISIT_REASON": "Ingresa el motivo de la visita",
                "ENTITY_MAG_DESC": "Descripción de este tipo de reportes",
                "PARAMS": "Parámetros",
                "MANDATORY_INFO": "Información obligatoria",
                "QR_CODE_SCANNER": "Escáner de código QR/DNI",
                "QR_CODE_ACTIVE_DESC": "Si está activo se podrá utilizar el escáner.",
                "VISIT_ACTIVE_DESC": "Empleados de baja/inactivos con documentación adeudada pueden ingresar como visitas.",
                "PREFERENCES": "Preferencias",
                "OPENING_ACTIVE_DESC": "Si está activo es obligatorio seleccionar una apertura una vez que esté logueado.",
                "ENTITY_MANAGEMENT": "Gestión de entidades",
                "OPENINGS": "Aperturas",
                "ENABLE_OPENINGS": "Habilitar aperturas en la app.",
                "SEARCH_OPENNINGS": "Buscar aperturas",
                "ENTRY_DEPARTURE": "Ingresos / Egresos",
                "PERMANENCE": "Permanencia",
                "TODAY": "Hoy",
                "ALL": "Todos",
                "TYPES": "Tipos",
                "PERMISSIONS_ERROR": "Usted no tiene permisos, hablar con el Administrador.",
                "UNDERSTOOD": "Entendido",
                "RESOURCES_IN_OPENING_ERROR": "No se puede deshabilitar la apertura ya que tiene ingresos registrados.",
                "RESOURCES_IN_WITHOUT_OPENING_ERROR": "Error, hay recursos ingresados sin la apertura.",
                "ENTITY_CONFIG": "Configuración de entidades",
                "PARAMS_CONFIG": "Configuración de parámetros",
                "DATA_BASICS_CONFIG": "Configuración de datos básicos",
                "PREFERENCES_CONFIG": "Configuración de preferencias",
                "NO_OPENING": "Sin Apertura",
                "PERMANENCE_TIME": "Tiempo de permanencia",
                "WRITE_VISIT_VEHICLE_DATA": "Ingresa datos del vehículo",
                "RES_NAME": "Nombre del recurso",
                "TYPE": "Tipo",
                "CONTRACTOR_CUIT": "Cuit del contratista",
                "MOVEMENTS": "Movimientos",
                "TIME_ELAPSED": "Tiempo transcurrido",
                "BUILDING": "Edificio",
                "AREA": "Área",
                "MINUTES": "Minutos",
                "PLANT_RESOURCES": "Recursos en planta",
                "DOWNLOAD_REPORT": "Descagar reporte",
                "EMP_DETAIL": "Detalle del empleado",
                "ENTER_VEHICLE_VISIT_PATENT": "Ingresa número de pantente",
                "ENTER_VEHICLE_VISIT_MODEL": "Ingresa modelo",
                "ENTER_OBSERVATIONS": "Ingresa observaciones",
                "REPORT": "Reporte",
                "VEH_DETAIL": "Detalle del vehículo",
                "VIS_DETAIL": "Detalle de la visita",
                "DETAIL": "Detalle",
                "MOV_DETAIL": "Detalle de movimientos",
                "MINUTE": "Minuto",
                "RES_PERMANENCE_DETAIL": "Detalle de permanencia de recursos",
                "EMPLOYEE_NO_ACCESS_OPENING_ERROR": "El recurso no pertenece a la apertura seleccionada",
                "LINK_EXPIRED": "Link caducado",
                "EXCEPTED": "Exceptuado",
                "RES_ENTERED": "Recursos ingresados",
                "PAGE": "Página",
                "OF": "de",
                "NORMAL_HS": "Horas normales",
                "50%_HS": "Horas extras 50%",
                "100%_HS": "Horas extras 100%",
                "NORMAL_HS_SHORT": "Hs normales",
                "50%_HS_SHORT": "Hs extras 50%",
                "100%_HS_SHORT": "Hs extras 100%",
                "RESOURCE_DATA": "Datos del Recurso",
                "USER_ACCESS": "Usuario ingreso",
                "USER_EXIT": "Usuario egreso",
                "TOTAL_HS": "Total de horas",
                "TOTAL_HS_PER": "Horas totales por",
                "RECORDS": "Registros",
                "BY": "Por",
                "ERROR_TRY_AGAIN": "Ocurrio un error, por favor vuelve a intentar.",
                "NOT_ENABLE_OPENING_WITHOUT_OPNING": "No puede habilitarla ya que tiene ingresado recursos sin una ",
                "ASSIGNED2": "asignada",
                "REQUESTS": "Consultas",
                "ERROR_DATA_ENTER": "Ocurrio un error, por favor verifique los datos ingresados",
                "DOWNLOAD_APP": "Instalar acceso directo",
                "EMPLOYEE_HAVE_FUTURE_INCOME_ERROR": "El ID consultado corresponde a un empleado cuya fecha de ingreso a Exactian es futura",
                "AUTHORIZED_BY": "Autorizado por",
                "CHOOSE_CAMERA": "Seleccione una camara para escanear",
                "NAME_OF_ENTITIES": "Nombre de entidades",
                "CONF_NAME_OF_ENTITIES": "Configuración de Nombre de entidades",
                "CREATE": "Crear",
                "ENTER_DESCRIPTION": "Ingresa una descripción",
                "RESOURCES_IN_BUILDING_ERROR": `No se puede deshabilitar ya que tiene ingresos registrados.`,
                "CREATED_SUCCESSFULLY": "creado con éxito",
                "EDITED_SUCCESSFULLY": "editado con éxito",
                "DELETED_SUCCESSFULLY": "eliminado con éxito",
                "ARE_YOU_SURE_DELETE": "¿ Está seguro que desea eliminar",
                "CHOOSE_BUILD": "Seleccione un",
                "NO_BUILDING": "Sin Edificio",
                "THE_RESOURCE_IS_ALREADY_IN": "El recurso ya se encuentra ingresado en el",
                "NO_ASSIGNMENT": "Sin asignación",
                "CODE_ALREADY_EXIST": "El código ya existe, por favor cambiar el código.",
                "RESOURCES_IN_BUILDING_ERROR_TO_DELETE": `No se puede eliminar ya que tiene ingresos registrados.`,
                "NOT_ACCESS_OPENING": `no existe o está deshabilitada.`,
                "BUILDINGS_IN_OPENING": `La accion no puede realizarse porque tiene asignado`,
                "THERE_ARE": `Hay`,
                "WITHOUT": `sin`,
                "ASSOCIATED": `asociadas`,
                "CANT_DELETE_FOR_ENTRYS": `No se puede eliminar ya que tiene ingresos registrados.`,
                "CANT_ENABLE_FOR_ENTRYS": `No se puede deshabilitar ya que tiene ingresos registrados.`,
                "CANT_DELETE_FOR_ASSIGNED_TO_USER": `No se puede eliminar ya que la entidad está asignada a un usuario.`,
                "CANT_DELETE_BUILDING_HAS_AREAS_ERROR": `No se puede eliminar ya que tiene areas asignadas.`,
                "FREE_ACCESS_AREA": "Acceso Libre",
                "ACCESS_ONLY_TO": "Acceso solo a",
                "SELECT_PERSON_TO_VISIT": "Selecciona persona a la que visitan",
                "PERSON_VISITED": "Persona visitada",
                "SURNAME": "Apellido",
                "PERSON_TO_VISIT": "Persona a visitar",
                "CONFIG_PERSON_TO_VISIT": "Configuración de Personas a visitar",
                "SECTORS": "Sectores",
                "CONFIG_SECTOR": "Configuración de sectores",
                "SECTOR": "Sector",
                "AMOUNT_PEOPLE_ALLOWED": "Cantidad de personas permitidas",
                "ALLOW_PEOPLE_TO_VISIT": "Habilitar como dato obligatorio personas a visitar",
                "NOT_EXIST_SECTOR_ERROR": "El sector no existe o se encuentra deshabilitado",
                "NAME_ALREADY_EXIST": "El nombre ya existe, por favor cambiar el nombre.",
                "DNI_ID_ALREADY_EXIST": "El DNI / ID ya existe, por favor cambiar el DNI / ID.",
                "OPENING_HAS_BUILDINGS_ERROR_SELECTED": "Seleccionó una apertura que tiene edificios. Por favor seleccione el edificio.",
                "RESOURCE_IN_VISITED_ERROR": "No se puede deshabilitar la persona porque está siendo visitada.",
                "PERSON_VISITED_ERROR": "No se puede eliminar la persona porque ya fue visitada.",
                "SECTOR_USED_ERROR": "No se puede deshabilitar o eliminar el sector porque se está usando.",
                "CANT_DELETE_BUILDING_HAS_PERSON_ERROR": `No se puede eliminar ya que tiene personas a visitar asignadas.`,
                "WITHOUT_SECTOR": `Sin sector`,
                "OPENING_WITH_PERSON_ASIGNED_ERROR": `No se puede deshabilitar porque tiene un persona a visitar asignada.`,
                "NOT_ACCESS_OPENING_START": "El ingreso no ha podido ser completado, por estar logueado sin",
                "NOT_ACCESS_OPENING_START_MID": ", y existen",
                "NOT_ACCESS_OPENING_MID": "de Ingreso habilitadas. Por favor, volver a loguearse en una",
                "NOT_ACCESS_OPENING_END": "de ingreso específica para poder realizar ingresos/egresos",
                "BUILDINGS_WITHOUT_OPENING_START": "El ingreso no ha podido ser completado, por estar logueado sin",
                "BUILDINGS_WITHOUT_OPENING_START_MID": ", y existen",
                "BUILDINGS_WITHOUT_OPENING_MID": "habilitados. Por favor, volver a loguearse en un",
                "BUILDINGS_WITHOUT_OPENING_END": "específico para poder realizar ingresos/egresos",
                "NOT_ENABLE_BUILDING_WITHOUT_BUILDING": "No puede habilitarlo ya que tiene ingresado recursos sin un ",
                "MANDATORY_PEOPLE_TO_VISIT_ERROR": 'Por favor configurar al menos una "persona a vistar"',
                "MAXIMUM_PEOPLE_TO_VISIT_ERROR": "La cantidad de personas seleccionadas supera el cupo permitido",
                "EQUIPMENT_OR_TOOLS": "Equipo o herramientas",
                "THE_PERSON_ACCESS_WITH_EQUIPMENT_OR_TOOLS": "La persona ingresa con equipos o herramientas.",
                "SELECT_WITH_EQUIPMENT_OR_TOOLS": "Selecciona equipo o herramienta",
                "EQUIPMENT_OR_TOOLS_SELECTABLE": "Equipo / herramientas",
                "ADD_INFO_OF_TOOL_OR_EQUIPMENT": "Ingrese información adicional como el código o modelo del equipo",
                "TYPE_EQUIPMENT_OR_TOOLS": "Tipo de equipos o herramientas",
                "TYPE_EQUIPMENT_OR_TOOL_CREATE_SUCCESSFULLY": "Tipo de equipos o herramientas creado con éxito",
                "TYPE_EQUIPMENT_OR_TOOL_EDIT_SUCCESSFULLY": "Tipo de equipos o herramientas editado con éxito",
                "TYPE_EQUIPMENT_OR_TOOL_DELETED_SUCCESSFULLY": "Tipo de equipos o herramientas eliminado con éxito",
                "TYPE_EQUIPMENT_OR_TOOL_NAME_ALREADY_EXIST": "El nombre ya existe, por favor cambiar el nombre.",
                "TYPE_EQUIPMENT_OR_TOOL_NAME_CANNOT_DISABLED": "Existe un recurso ingresado sin salida que ingresó con este tipo de equipamiento",
                "TYPE_EQUIPMENT_OR_TOOL_NAME_CANNOT_DELETE": "No se puede eliminar el equipamiento por qué ya fue usado",
                "CONFIG_EQUIPMENT_OR_TOOLS": "Configurar tipos de equipo o herramientas",
                "EQUIPMENT_DATA_NO_CONFIRM": "Existe información de un equipamiento sin confirmar.",
                "EQUIPMENT_DATA_NO_COMPLETED": "Ingresó información incompleta de un nuevo vehículo.",
                "EQUIPMENT_NOT_EXIST_OR_DISABLED_ERROR": "Tipo de equipamiento seleccionado no existe o esta deshabilitado",
                "NO_EQUIPMENT": "Sin equipamiento",
                "THE_ACCESS_RECORD_WAS_MODIFY_AT_THE_DATE": "La fecha de ingreso fue modificada el día",
                "THE_EXIT_RECORD_WAS_MODIFY_AT_THE_DATE": "La fecha de egreso fue modificada el día",
                "VIEW_DUE_DOC": "Ver Documentación adeudada",
                "DUE_DOC_OF": "Documentación adeudada de",
                "DUE_DOC_OF_THE_RESOURCE": "Documentación adeudada del recurso",
                "CANT_ADD_VEH_WITH_THE_SAME_PATENT": "No puede agregar el vehículo porque ya existe uno con la misma patente.",
                "FILTER_MORE_FOR_DOWNLOAD": "Filtrar más para descargar reporte",
                "CANNOT_CREATE_THE": `No puede crearse el`,
                "CANNOT_CREATE": `No puede crearse la`,
                "BECAUSE_EXISTING_RESOURCES_IN_THE": `debido a que existen recursos ingresados en`,
                "BECAUSE_EXISTING_RESOURCES_IN": `debido a que existen recursos ingresados en la`,
                "WHITOUT": "Sin",
                "CANNOT_ENABLE_THE": `No puede habilitarse el`,
                "CANNOT_ENABLE": `No puede habilitarse la`,
                "SHOW_CONTRACTS_DETAILS": `Ver Detalle de contratos`,
                "CONTRACTS_DETAILS": `Detalle de contratos`,
                "EMP_HAS_NOT_CONTRACTS_ASSIGNED": `El empleado no se encuentra asignado a ningún contrato`,
                "VEH_HAS_NOT_CONTRACTS_ASSIGNED": `El vehículo no se encuentra asignado a ningún contrato`,
                "INVALID_DATE_MODIFICATION": "No se puede modificar la fecha ya que generaría un conflicto con otros movimientos existentes.",
                "PRIVACY_POLICY": "Política de privacidad",
                "ENTRIES": "Ingresos",
                "AREA_SELECT": "Seleccionar área",
                "MANDATORY_AREA_SELECT": "Se requiere especificar el área y la opción 'Acceso libre' no estará disponible.",
                "EDITED_BY": "Editado por",
                "REASON": "Motivo",
                "DATE_SINCE_CANT_BE_MORE_THAN_UNTIL_DATE": "La fecha desde no puede mayor a la fecha hasta",
                "DATE_RANGE_CANT_BE_MORE_THAN_ONE_YEAR": "El rango de fechas no puede ser mayor a 1 año",
                "DATE_RANGE_CANT_BE_FUTURE": "El rango de fechas no puede ser futura",
                "CONSIDER_CONTRACTS_FOR_RESOURCE_APTITUDE":"Contemplar contratos para definir aptitud del recurso",
                "CONTRACTS_FOR_RESOURCE_APTITUDE_DESC":"Al habilitar esta opción, la aplicación de ingresos contemplará el estado de todos los contratos del recurso para definir si se encuentra apto o no apto para ingresar.",
                "DUE_DOC_CONTRACTS": "Documentación adeudada de contratos",
                "CONTRACTS_CONSIDERED_FOR_ENTRY": "El estado de los contratos se tiene en cuenta para el ingreso.",
                "CONTRACTS_NOT_CONSIDERED_FOR_ENTRY": "El estado de los contratos no se tiene en cuenta para el ingreso.",
                "CONTRACTS_CONT_STATUS_CONSIDERED_ENTRY_EMP": "El estado de los contratos del contratista se considera para el ingreso, incluso sin asignación al empleado.",
                "CONTRACTS_CONT_STATUS_CONSIDERED_ENTRY_VEH": "El estado de los contratos del contratista se considera para el ingreso, incluso sin asignación al vehículo.",
                "CONTRACT_DATE_VALIDITY_TOOLTIP": "La fecha corresponde a la vigencia del contrato",
                "CONTRACT_DATE_RESOURCE_ASSIGNMENT_TOOLTIP": "La fecha corresponde a la asignación del recurso al contrato",
        }
}